"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function BuildPagination(currentPage, items, paginationSetting) {
    if (paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.nbItemPerPage) {
        if ((paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.currentPage) != null &&
            (paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.totalPage) != null) {
            return undefined;
        }
        var totalPage = items
            ? Math.ceil(items.length / (paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.nbItemPerPage))
            : 0;
        return {
            totalPage: totalPage,
            currentPage: currentPage < totalPage ? currentPage : 0,
            paginationSetting: paginationSetting,
        };
    }
}
exports.BuildPagination = BuildPagination;
function pagination(items, pageInfo) {
    if (items && pageInfo) {
        var startIndex = pageInfo.paginationSetting.nbItemPerPage * pageInfo.currentPage;
        var endIndex = startIndex + pageInfo.paginationSetting.nbItemPerPage;
        var view = items.slice(startIndex, endIndex < items.length ? endIndex : items.length);
        return view;
    }
    return items;
}
exports.pagination = pagination;
function copyAndSortItems(items, filter, objAccessor, columnKey, isSortedDescending) {
    var key = columnKey;
    var arrayObject = items.slice(0);
    if (filter) {
        arrayObject = arrayObject.filter(filter);
    }
    if (columnKey) {
        return arrayObject.sort(function (a, b) {
            var mul = isSortedDescending ? -1 : 1;
            var objA = objAccessor(a);
            var objB = objAccessor(b);
            if (objA[key] !== null && (objB[key] === null || objB[key] === undefined)) {
                return -1 * mul;
            }
            if ((objA[key] === null || objA[key] === undefined) && objB[key] !== null) {
                return 1 * mul;
            }
            if (objA[key] !== null && objB[key] !== null) {
                if (objA[key] === objB[key]) {
                    return 0;
                }
                if (objA[key] < objB[key]) {
                    return -1 * mul;
                }
                return 1 * mul;
            }
            return 0;
        });
    }
    return arrayObject;
}
exports.copyAndSortItems = copyAndSortItems;
//# sourceMappingURL=ItemHelper.js.map